import React from "react";

export default function ConsolidatedReportUI({ data }) {
  if (!data || data.length === 0)
    return <div className="text-muted text-center py-3">No data available</div>;

  const late = data.filter((r) => r.late_minutes !== "0m");
  const early = data.filter((r) => r.early_minutes !== "0m");
  const absent = data.filter((r) => r.status === "Absent");

  return (
    <div className="consolidated-report">
      <h5 className="mt-3 fw-bold">Late Comers ({late.length})</h5>

      {late.length === 0 ? (
        <p className="text-muted">No records found.</p>
      ) : (
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Department</th>
              <th>Outlet</th>
              <th>In Time</th>
              <th>Late By</th>
            </tr>
          </thead>
          <tbody>
            {late.map((r, i) => (
              <tr key={i}>
                <td>{r.employee_code}</td>
                <td>{r.name}</td>
                <td>{r.outlet}</td>
                <td>{r.department}</td>
                <td>{r.in_time}</td>
                <td>{r.late_minutes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <h5 className="mt-4 fw-bold">Early Goers ({early.length})</h5>

      {early.length === 0 ? (
        <p className="text-muted">No records found.</p>
      ) : (
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Department</th>
              <th>Outlet</th>
              <th>Out Time</th>
              <th>Early By</th>
            </tr>
          </thead>
          <tbody>
            {early.map((r, i) => (
              <tr key={i}>
                <td>{r.employee_code}</td>
                <td>{r.name}</td>
                <td>{r.department}</td>
                <td>{r.outelt}</td>
                <td>{r.out_time}</td>
                <td>{r.early_minutes}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      <h5 className="mt-4 fw-bold">Absentees ({absent.length})</h5>

      {absent.length === 0 ? (
        <p className="text-muted">No records found.</p>
      ) : (
        <table className="table table-bordered">
          <thead className="table-light">
            <tr>
              <th>Code</th>
              <th>Name</th>
              <th>Department</th>
              <th>Outlet</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {absent.map((r, i) => (
              <tr key={i}>
                <td>{r.employee_code}</td>
                <td>{r.name}</td>
                <td>{r.department}</td>
                <td>{r.outlet}</td>
                <td>{r.status}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {/* ========================== */}
      {/* STATUS LIST */}
      {/* ========================== */}
      <h5 className="mt-4 fw-bold">Employee Status List</h5>

      <table className="table table-bordered">
        <thead className="table-light">
          <tr>
            <th>Code</th>
            <th>Name</th>
            <th>Department</th>
            <th>Shift</th>
            <th>In</th>
            <th>Out</th>
            <th>Worked</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.map((r, i) => (
            <tr key={i}>
              <td>{r.employee_code}</td>

              <td>{r.name}</td>
              <td>{r.department}</td>
              <td>
                {r.shift_in} - {r.shift_out}
              </td>
              <td>{r.in_time}</td>
              <td>{r.out_time}</td>
              <td>{r.worked_minutes}</td>
              <td>{r.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
